import type { ContributorLifecycleStatus, RuntimeDepartment } from "./api/runtimeWorkspaceClient";

export function getContributorLifecycleStatus(department: RuntimeDepartment): ContributorLifecycleStatus {
  if (department.responseStatus === "submitted") return "submitted";
  if (department.responseStatus === "draft") return "in_progress";
  if (!department.participantUserId) return "open";
  if (department.participantHasPassword) return "active";
  return "invited";
}

export function contributorLifecycleLabel(status: ContributorLifecycleStatus, language: "de" | "en" = "de"): string {
  const labels: Record<"de" | "en", Record<ContributorLifecycleStatus, string>> = {
    de: {
      open: "Offen",
      invited: "Eingeladen",
      active: "Aktiv",
      in_progress: "In Bearbeitung",
      submitted: "Eingereicht"
    },
    en: {
      open: "Open",
      invited: "Invited",
      active: "Active",
      in_progress: "In progress",
      submitted: "Submitted"
    }
  };
  return labels[language][status];
}
